import {useRequiredConfig} from '@domain/shifthandover'
import {EventsTab} from '@hconnect/common/types'
import {Theme, useMediaQuery} from '@mui/material'
import {getFilterDifference, Page} from '@widgets/shift-event-filters'
import {FC} from 'react'

import {
  useTrackShiftEventsAnalytics,
  usePagedData,
  MOBILE_ELEMENTS_PER_PAGE,
  useNotifications
} from '../hooks'
import {Notification} from '../types'

import {NotificationsListView} from './NotificationsListView'

type NotificationsContainerProps = {
  plantId: string
  activeTab: EventsTab
  setActiveTab: (tab: EventsTab) => void
}

export const NotificationsContainer: FC<NotificationsContainerProps> = ({
  plantId,
  activeTab,
  setActiveTab
}) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const {country, shifts} = useRequiredConfig(plantId)
  const trackShiftEventAnalytics = useTrackShiftEventsAnalytics({plantId, country})

  const {
    data,
    isLoading,
    filterOptions,
    setFilters,
    changePage,
    setItemsPerPage,
    paginationOptions,
    shouldLoadNextPage
  } = usePagedData<Notification>({
    plantId,
    shifts,
    fetchData: useNotifications,
    pageType: Page.Notifications
  })

  return (
    <NotificationsListView
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      activeFilter={filterOptions}
      events={data?.items}
      isLoading={isLoading}
      onFilterChange={(nextFilterOptions) => {
        changePage(0)
        if (isMobile) {
          setItemsPerPage(MOBILE_ELEMENTS_PER_PAGE)
        }
        setFilters(nextFilterOptions)
        trackShiftEventAnalytics({
          name: 'userAdjustsFilter',
          data: {
            filterPage: 'notifications',
            filterName: getFilterDifference(nextFilterOptions, filterOptions)
          }
        })
      }}
      paginationOptions={isMobile ? undefined : paginationOptions}
      showBottomProgress={isMobile && shouldLoadNextPage}
      plantId={plantId}
    />
  )
}
